import { render, staticRenderFns } from "./TableLoader.vue?vue&type=template&id=56e84f92&scoped=true"
import script from "./TableLoader.vue?vue&type=script&lang=js"
export * from "./TableLoader.vue?vue&type=script&lang=js"
import style0 from "./TableLoader.vue?vue&type=style&index=0&id=56e84f92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e84f92",
  null
  
)

export default component.exports